module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline",
    attrs: {
      "slot": "select",
      "id": "selectArticleType"
    },
    slot: "select"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "articleType"
    }
  }, [_vm._v("Select component to create")]), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "id": "articleType",
      "name": "type"
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80c67f3e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select-template.vue
// module id = 227
// module chunks = 0